const reportWebVitals = onPerfEntry => {
    if (onPerfEntry && onPerfEntry instanceof Function) {
        try {
            import('web-vitals')
                .then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
                    getCLS(onPerfEntry);
                    getFID(onPerfEntry);
                    getFCP(onPerfEntry);
                    getLCP(onPerfEntry);
                    getTTFB(onPerfEntry);
                })
                .catch(err => {
                    console.warn('Failed to load web-vitals:', err);
                });
        } catch (error) {
            console.warn('Error importing web-vitals:', error);
        }
    }
};

export default reportWebVitals;
